// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"a967a7c0","703":"dd222d96"}[chunkId] + ".chunk.js";
};